import React from 'react';
import PropTypes from 'prop-types';
import { TOOLTIP_POSITION } from 'taboola-ultimate-ui';
import { TooltipWrapper } from 'components/TooltipWrapper/TooltipWrapper';
import { useGridContext } from 'modules/campaigns/modules/campaigns-reports/components/GridContextProvider/GridContextProvider';
import { LibraryPauseModal } from 'modules/campaigns/modules/campaigns-reports/components/LibraryPauseModal/LibraryPauseModal';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { useModal } from 'modules/taboola-common-frontend-modules/modals';
import { useLocalStorage } from 'modules/taboola-common-frontend-modules/storage';
import ToggleSwitchCellRenderer from './ToggleSwitchCellRenderer';

const LIBRARY_PAUSE_MODAL_KEY = 'shouldHideCreativeLibraryPauseModal';

const TooltipMessage = value => (
    <FormattedMessage id={`app.campaigns.creative-library.state.tooltip.${value}`} defaultMessage="Creative Status" />
);

const getModalMessage = () => ({
    title: (
        <FormattedMessage
            id="app.campaigns.creativeReports.actions.pause.creative-library.header"
            tagName="h2"
            defaultMessage="Pause Confirmation"
        />
    ),
    contentRenderer: LibraryPauseModal,
});

export const CreativeLibraryStateCellRenderer = ({ data, isDisabled, ...rest }) => {
    const { isGridEditDisabled } = useGridContext();
    const { open: openModal } = useModal();
    const { context } = rest;
    const tooltipContent = <TooltipMessage data={data} />;
    const [getLocalStorage] = useLocalStorage();

    const shouldShowModal = !getLocalStorage(LIBRARY_PAUSE_MODAL_KEY);

    const handleToggle = async toggled => {
        if (!toggled && shouldShowModal) {
            return await openModal(getModalMessage());
        }
        return true;
    };

    return (
        <TooltipWrapper
            tooltipContent={tooltipContent}
            tooltipOptions={{ interactive: false, arrow: true, placement: TOOLTIP_POSITION.RIGHT }}
        >
            <ToggleSwitchCellRenderer
                {...rest}
                onToggled={handleToggle}
                data={data}
                disabled={isGridEditDisabled || isDisabled(data, context)}
            />
        </TooltipWrapper>
    );
};

CreativeLibraryStateCellRenderer.propTypes = {
    ...ToggleSwitchCellRenderer.propTypes,
    isDisabled: PropTypes.func,
};
